<div class="col">
  <div class="row justify-content-between g-4 p-4">
    <div class="col p-1">
      <button type="button" class="btn btn-secondary btn-lg rounded-3" [routerLink]="['/../events']">
        <h3 class="font-size-36">Back</h3>
      </button>
    </div>
    <div class="col-auto">
      <h3 class="font-size-36"></h3>
    </div>
  </div>

  <div class="row row-cols-auto justify-content-between g-4 p-4">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="row p-1">
            <h3 class="font-size-36 col p-0">
              {{ event.eventName }}
            </h3>
          </div>

          <div class="row justify-content-between p-1">
            
            <div class="bg-primary p-1 rounded-3 col-auto">
              <div class="row justify-content-center p-1 g-1">
                <img class="white-svg col-auto" src="users-solid-full.svg" width="30" height="24" alt="clock"/>
                <div class="font-size-16 text-white col-auto"> {{ event.vacancies }} Seats left </div>
              </div>
            </div>

            <div class="bg-primary p-1 rounded-3 col-auto">
              <div class="row justify-content-center p-1 g-1">
                <img class="white-svg col-auto" src="calendar-solid-full.svg" width="30" height="24" alt="calander"/>
                <div class="font-size-16 text-white col-auto"> {{  getDate(event) }} </div>
              </div>
            </div>

            <div class="bg-primary p-1 rounded-3 col-auto">
              <div class="row justify-content-center p-1 g-1">
                <img class="white-svg col-auto" src="clock-solid-full.svg" width="30" height="24" alt="clock"/>
                <div class="font-size-16 text-white col-auto"> {{  getTime(event) }} </div>
              </div>
            </div>

            <div class="bg-primary p-1 rounded-3 col-auto">
              <div class="row justify-content-center p-1 g-1">
                <img class="white-svg col-auto" src="location-dot-solid-full.svg" width="30" height="24" alt="location"/>
                <div class="font-size-16 text-white col-auto">{{ event.eventLocation }}</div>
              </div>
            </div>

          </div>
          
          <div class="row p-1">
            <hr/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="row">
            <img class="primary-svg col-auto" src="file-lines-regular-full.svg" width="60" height="40" alt="location"/>
            <h3 class="font-size-32 col">
              About This Event
            </h3>
          </div>
          <div class="row">
            <div class="col">
              <p class="font-size-16">{{ event.about }}</p>
            </div>
          </div>

          <div class="row my-2">
            <div class="col bg-primary p-4 rounded-3 row-gap-2">
              <div class="row">
                <div class="col">
                  <h4 class="font-size-16 text-white">What You'll Experience</h4>
                </div>
              </div>
              @for (item of event.experience; track $index) {
              <div class="row align-items-center">
                <img class="white-svg col-auto" src="circle-check-regular-full.svg" width="30" height="24" alt="location"/>
                <div class="col font-size-16 text-white">{{ item }}</div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card col-12 col-lg-4 border-0">
      @if (event.imgUrls) {
        <ngb-carousel>
            @for (imgUrl of event.imgUrls; track imgUrl) {
            <ng-template ngbSlide>
                <div class="picsum-img-wrapper">
                <img src="https://cdn.wyvern-weaponry.com/{{ imgUrl }}" class="d-block w-100 crop card-img-top crop rounded-top-4" alt="...">
                </div>
            </ng-template>
            }
        </ngb-carousel>
    }

      <div class="position-absolute mt-3 bg-primary p-1 rounded-3">
        <div class="row justify-content-center p-1 g-1">
          <img class="white-svg col-auto" src="users-solid-full.svg" width="30" height="24" alt="clock"/>
          <div class="font-size-16 text-white col-auto"> {{ event.vacancies }} Seats left </div>
        </div>
      </div>

      <div class="card-body">
          @if(!event.cancelled) {
            <app-card-form [courseId]="event.id" [price]="event.price"/>
          } @else {
            <div class="d-grid gap-2">
              <button type="button" class="btn btn-primary btn-lg rounded-3 font-size-20" disabled>Cancelled</button>
            </div>
          }
      </div>
    </div>
  </div>
</div>
